module.exports = __webpack_public_path__ + "static/media/2-4.ca0bb178.webp";